import { useEffect, useState } from 'react';

import { Button } from 'components/ui/button';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from 'components/ui/dialog';
import { Input } from 'components/ui/input';
import { Label } from 'components/ui/label';

type SaveReportViewModalProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    defaultName?: string;
    isSaving?: boolean;
    onSave: (name: string) => void;
};

export function SaveReportViewModal({
    open,
    onOpenChange,
    defaultName = '',
    isSaving = false,
    onSave,
}: SaveReportViewModalProps) {
    const [name, setName] = useState(defaultName);

    useEffect(() => {
        if (open) {
            setName(defaultName);
        }
    }, [open, defaultName]);

    const trimmedName = name.trim();

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="reports-light-overlay w-[calc(100%-2rem)] overflow-hidden sm:max-w-md">
                <DialogHeader>
                    <DialogTitle>Save report view</DialogTitle>
                    <DialogDescription>
                        Save your current columns, filters, and sort as a reusable view.
                    </DialogDescription>
                </DialogHeader>

                <div className="min-w-0 space-y-2 py-2">
                    <Label htmlFor="report-view-name">View name</Label>
                    <Input
                        id="report-view-name"
                        value={name}
                        onChange={(event) => setName(event.target.value)}
                        placeholder="e.g. Orders for finance"
                        maxLength={120}
                        autoFocus
                        className="w-full min-w-0"
                    />
                </div>

                <DialogFooter>
                    <Button variant="outline" onClick={() => onOpenChange(false)} disabled={isSaving}>
                        Cancel
                    </Button>
                    <Button
                        disabled={!trimmedName || isSaving}
                        onClick={() => onSave(trimmedName)}
                    >
                        {isSaving ? 'Saving...' : 'Save view'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
